import React, { memo } from 'react';

interface ResultBlankTypes {
    word: string;
}
const ResultBlank = memo(({ word }: ResultBlankTypes) => {
  const wordTag = !word.includes('\n') ? <span key={word}>{word}</span> : word.split('\n').map((line: string, i: number) => {
    if (word.split('\n').length - 1 === i) {
      return <span key={i + line}>{line}</span>;
    }
    return <span key={i + line}>{line}<br /></span>;
  });
  return (
    <>
      {wordTag}
    </>
  );
});
export default ResultBlank;
